<template>
  <!--科技局临时展示页面-->
  <div class="frontPageBox">
    <!--    &lt;!&ndash;      通知 - 客户跟进情况 - 公告&ndash;&gt;-->
    <!--    <Notice/>-->
    <!--    &lt;!&ndash;      业绩目标 - 销售漏斗&ndash;&gt;-->
    <!--    <Target v-if="flag == true"/>-->
    <!--    &lt;!&ndash;      通话目标 - 成单分享&ndash;&gt;-->
    <!--    <goal-experience v-if="flag == true"/>-->
    <!--    &lt;!&ndash;      优秀战队/个人 - 业绩排名&ndash;&gt;-->
    <!--    <team-ranking v-if="flag == true"/>-->
    <!--    &lt;!&ndash;      战队目标&ndash;&gt;-->
    <!--    <team-goal v-if="flag == true"/>-->
    <el-row :gutter="20">
      <el-col :span="16">
        <el-card class="box-card">
          <div slot="header" class="box-card-title">
            <span style="font-weight: bold">快捷入口</span>
          </div>
           <div  style="display:flex;flex-direction:row;flex-wrap: nowrap;justify-content: space-around;align-items: center;height: 110px;">
              <div class="kjrk-box" >
                <img :src="`${publicPath}img/kjj/1.png`" class="kjrk-box-img" @click="skip(1)"></img>
                <span>租户信息</span>
              </div>
             <div class="kjrk-box">
               <img :src="`${publicPath}img/kjj/2.png`" class="kjrk-box-img" @click="skip(2)"></img>
               <span>高企档案</span>
             </div>
             <div class="kjrk-box">
               <img :src="`${publicPath}img/kjj/3.png`" class="kjrk-box-img" @click="skip(3)"></img>
               <span>客户档案</span>
             </div>
             <div class="kjrk-box">
               <img :src="`${publicPath}img/kjj/4.png`" class="kjrk-box-img" @click="skip(4)"></img>
               <span>会议登记</span>
             </div>
<!--             <div class="kjrk-box">-->
<!--               <img :src="`${publicPath}img/kjj/5.png`" class="kjrk-box-img"></img>-->
<!--               <span>个人中心</span>-->
<!--             </div>-->
             <div class="kjrk-box">
               <img :src="`${publicPath}img/kjj/6.png`" class="kjrk-box-img" @click="skip(5)"></img>
               <span>试用列表</span>
             </div>
           </div>
        </el-card>
      </el-col>
      <el-col :span="8">
        <el-card class="box-card">
          <div slot="header" class="box-card-title">
            <span>办公信息</span>
          </div>
          <div class="box-card-content-bgxx">
            <div class="box-card-content-title-bgxx">电话</div>
            <span class="box-card-content-title-mh-bgxx">:</span>
            <div>0530-5298378</div>
          </div>
          <div class="box-card-content-bgxx">
            <div class="box-card-content-title-bgxx">邮箱</div>
            <span class="box-card-content-title-mh-bgxx">:</span>
            <div>gaoguanchaoadmin@hz.shangdong.cn</div>
          </div>
          <div class="box-card-content-bgxx">
            <div class="box-card-content-title-bgxx">地址</div>
            <span class="box-card-content-title-mh-bgxx">:</span>
            <div>菏泽市牡丹区公务大厦9008室</div>
          </div>
          <div class="box-card-content-bgxx">
            <div class="box-card-content-title-bgxx">办公时间</div>
            <span class="box-card-content-title-mh-bgxx">:</span>
            <div>上午8:30-12:00;下午14:30-18:00(法定工作日,夏季);<br/>上午8:30-12:00;下午14:30-17:30(法定工作日,冬季);</div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card style="height: 300px;">
          <div slot="header" class="box-card-title">
            <span style="font-weight: bold">菏泽市牡丹区科学技术局</span>
          </div>
          <div style="display: flex;flex-direction: row">
                  <div><img :src="`${publicPath}img/kjj/hjkjj_desc.png`" style="width: 160px;height: 200px;"/></div>
                  <div style="margin-left: 20px;width: 100%;">
                    <div style="background-color:rgba(0, 121, 254, 0.1);line-height: 40px;padding-left: 16px">菏泽市牡丹区科技局是贯彻党中央关于科技创新工作的方针政策和决策部署，落实省委、市委和区委工作要求，在履行职责过程中坚持和加强党对科技创新工作的集中统一领导。</div>
                    <div style="margin-top: 20px;">牡丹区科技局将在以下几个方面狠下功夫：</div>
                    <div> <span style="font-weight: bold">一是进一步强化对“科技是第一生产力”的认识。</span>通过宣传《科技进步法》，利用多种形式进行宣传教育，在全区上下形成一个好的科技环境，增强全民科技发展意识，让大家都来关心支持科技推动科技发展。 </div>
                    <div> <span style="font-weight: bold">二是为推动科技进步提高企业自主创新能力。</span>进一步加大科技投入，确保科技研发资金到位、监管到位。 </div>
                    <div><span style="font-weight: bold">三是建立完善有效地政策激励机制。</span>对为科技工作做出重大贡献的，对在企业自主方面做出重大贡献的，对企业用于自主研发创新，引进高科技人才等方面予以政策扶持和表彰奖励。 </div>
                    <div> <span style="font-weight: bold">四是进一步改造传统产业，拓展科技创新领域。</span>在对现存医药化工机械电子进一步加大支持扶持基础上，拓宽林产品、纺织品、食品加工领域，调整产业结构促进产业升级。 </div>
                    <div><span style="font-weight: bold">五是完善科技管理机制，实现科技资源共享。</span>筹建科技信息服务平台，发展企业科技文化，抓好科技队伍建设，在工作定位上跳出“项目科技”的小圈子，真正把工作落脚点、聚焦点，提高核心竞争力，做强做大优势产业集群上来； </div>
                    <div>在工作方式上完善整合利用国内外的优势科技资源，为牡丹区经济社会发展服务；在工作重点上要加快科技成果向现实生产力的转化，今后重大专项、创新型企业试点、高新技术企业等科技计划，都要以企业拥有自主产权和自主品牌为先决条件。</div>
                  </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
export default {
  name: "index_kjj",
  data() {
    return {
      publicPath:process.env.BASE_URL,
    }
  },
  components: {},
  methods: {
    toLink(url) {
      this.$router.push(url);
    },
    skip(num){
      if (num=='1'){
        this.toLink('/tenantinfo/index')
      }else if (num=='2'){
        this.toLink('/customer/gqzdxx')
      }else if (num=='3'){
        this.toLink('/customer/company')
      }else if (num=='4'){
        this.toLink('/system/tyhdgl')
      }else if (num=='5'){
        this.toLink('/system/useraccount')
      }
    }
  }
}
</script>

<style scoped lang="scss">
//.frontPageBox {
//  width: 1648px;
//  //margin: 0 auto;
//  background-color: rgba(240, 242, 245, 0.5);
//}
::v-deep .el-table th.is-leaf {
  background: #ffffff !important;
  color: #8b8b8b;
  text-align: center;
}
.kjrk-box{
  width: 90px;
  height: 90px;
  //background-color: rosybrown;
  display: flex;
  flex-direction: column;
  justify-content: center;
  cursor: pointer;
  align-items: center
}
.kjrk-box-img{
  width: 65px;
  height: 65px;
  margin-bottom: 10px;
}
.box-card {
  height: 180px;
}

.box-card-title {
  font-weight: bold;
  font-size: 16px;
}

.box-card-content-bgxx {
  display: flex;
  flex-direction: row;
  line-height: 22px;
}

.box-card-content-title-bgxx {
  font-weight: bold;
  width: 60px;
  text-align-last: justify;
  //background-color: coral;
}
.box-card-content-title-mh-bgxx{
  font-weight: bold;
  margin-right: 5px;
}


.grid-content {
  border-radius: 4px;
  min-height: 146px;
}

.bg-purple {
  background: #d3dce6;
}
</style>
